// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../services/auth/authApi";
import { apiSlice } from "../services/api/apiSlice";
import { persistReducer, persistStore } from "redux-persist";
import { persistConfig } from "../utils/store";
import rootReducer from "./rootReducer";

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(authApi.middleware, apiSlice.middleware),
});

export const persistor = persistStore(store);

// Tipos para el store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
